import React from "react";
import { Box, Button, SxProps, useMediaQuery, useTheme } from "@mui/material";
import { getFlightCardTranslations } from "../../../utils/translationsUtils";
import { useDispatch, useSelector } from "react-redux";
import { selectedItinerarySelector } from "../../../redux/selectedItinerary/selectedItinerary.selector";
import { useTranslations } from "../../../hooks/useTranslations";
import {
  setIndexOfRequestedItinerary,
  setSelectedBrandedFareId,
} from "../../../redux/selectedItinerary/selectedItinerary.slice";
import { setIsValid } from "../../../redux/checkoutSteps/checkoutSteps.slice";
import { BrandedFaresSlider } from "@thekilroygroup/shared-ui";

export interface IProps {
  handleProceed: () => void;
  valid: boolean;
}
export const BrandedFares = (props: IProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const selectedItinerary = useSelector(selectedItinerarySelector);
  const brandedFaresJSON = {
    itineraries: selectedItinerary.itineraries,
    includesBrandedFares: selectedItinerary.includesBrandedFares,
    indexOfRequestedItinerary: selectedItinerary.indexOfRequestedItinerary,
    brandedFareId: selectedItinerary.brandedFareId,
  };

  const {
    translations,
    translations: {
      brandedFares: {
        categories,
        features,
        blacklistedServiceGroups,
        blacklistedSubCodes,
      },
    },
  } = useTranslations();
  let flightCardTranslations = getFlightCardTranslations(translations);
  const { nextStepButtonContainer } = sxStyles;
  return (
    <>
      <Box
        sx={{
          mt: { md: 2 },
          "& .button-container": {
            mt: -3,
            mb: 5,
            mr: 3,
            zIndex: 3,
            position: "relative",
          },
        }}
      >
        <BrandedFaresSlider
          {...flightCardTranslations}
          categoriesTranslations={categories}
          featureTranslations={features}
          brandedFaresJSON={brandedFaresJSON}
          passengerTypesMapTranslations={
            flightCardTranslations.passengerTypesMap
          }
          passengerTypesTranslations={
            flightCardTranslations.baggageInfoTranslations.passengerTypes
          }
          blacklistedSubCodes={Object.keys(blacklistedSubCodes || {})}
          blacklistedServiceGroups={Object.keys(blacklistedServiceGroups || {})}
          cardSize={320}
          selectedBrandId={selectedItinerary.brandedFareId}
          onSelectFare={(brandId: string, index) => {
            dispatch(setSelectedBrandedFareId(brandId));
            dispatch(setIndexOfRequestedItinerary(index));
            dispatch(setIsValid({ key: "brandedFares", valid: true }));
          }}
        />
      </Box>
      <Box sx={nextStepButtonContainer}>
        <Button
          color="primary"
          size={isDesktop ? "large" : "xLarge"}
          variant={isDesktop ? "outlined" : "contained"}
          fullWidth={!isDesktop}
          disabled={!props.valid}
          disableElevation
          onClick={props.handleProceed}
          sx={{ zIndex: 3 }}
        >
          {translations.navigation.nextStep}
        </Button>
      </Box>
    </>
  );
};

const sxStyles: { [key: string]: SxProps } = {
  nextStepButtonContainer: {
    mt: 2,
    mr: { md: 3 },
    pb: 4,
    display: { md: "flex" },
    padding: { md: 0 },
    justifyContent: { md: "flex-end" },
  },
};
